import React, { useState } from "react"
import { X } from "lucide-react"

const TagInput = ({ tags, onUpdateAdSets, campaignNames, adAndAdsetMapping }) => {
  const [inputValue, setInputValue] = useState("")

  const removeTag = (tagToRemove) => {
    const newTags = tags.filter((tag) => tag !== tagToRemove)
    onUpdateAdSets(newTags)
  }

  return (
    <div className="flex flex-wrap gap-1 p-2 rounded-md bg-white min-h-[42px]">
      {tags?.map((tag, index) => {
        const campaignName = adAndAdsetMapping.find(
          mapping => mapping.adsetName === tag
        )?.campaignName;

        return (
          <div
            key={tag}
            className="flex flex-col bg-blue-100 px-2 py-1 rounded-md text-sm group transition-all max-w-full"
          >
            <div>
              <span className="text-blue-800 break-words overflow-hidden text-ellipsis mr-1" style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                {tag}
              </span>
              <button
                type="button"
                onClick={() => removeTag(tag)}
                className="ml-1 text-blue-600 hover:text-blue-800 focus:outline-none"
              >
                <X size={14} />
              </button>
            </div>
            <div>
              <span className="text-xs text-gray-700 break-words" style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                campaign: {campaignName}
              </span>
            </div>
          </div>
        );
      })}
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        // placeholder={tags?.length === 0 ? placeholder : ""}
        className="flex-grow outline-none min-w-[60px] bg-transparent text-sm"
        disabled={true}
      />
    </div>
  )
}

export default TagInput
